import { Component, OnInit, AfterContentInit, ElementRef, ViewChild, ContentChildren, QueryList, HostListener } from '@angular/core';
import { VideoListItemComponent } from '../video-list-item/video-list-item.component';
import { BaseComponent } from '../base-component';

@Component({
  selector: 'video-list',
  templateUrl: './video-list.component.html',
  styleUrls: ['./video-list.component.scss']
})
export class VideoListComponent extends BaseComponent {

  constructor(
    private element : ElementRef
  ) {
    super();
  }

  init() {
    this._windowResize = () => {
      this.onResize();
    }

    if (typeof window !== 'undefined')
      window.addEventListener('resize', this._windowResize);
  }

  private _windowResize;

  destroy() {
    if (typeof window !== 'undefined')
      window.removeEventListener('resize', this._windowResize);
  }

  ngAfterContentInit() {

  }

  @ViewChild('trackContainer', { static: true })
  trackContainerElement : ElementRef;

  @ContentChildren(VideoListItemComponent)
  items : QueryList<VideoListItemComponent>;

  scrollPosition : number = 0;

  get itemSizePx() : number {
    if (!this.items || this.items.length < 2)
      return 0;
    
    let items = this.items.toArray();
    let item : VideoListItemComponent = this.items[0];
    let width = items[1].widthPx;

    return width;
  }

  get itemSizeMargin() : number {
    if (!this.items || this.items.length < 2)
      return 0;
    
    let items = this.items.toArray();
    let item : VideoListItemComponent = this.items[0];
    let margin = items[0].offsetPx * 2.0;
    return margin;
  }

  get availableWidthPx() : number {
    let el : HTMLElement = this.trackContainerElement.nativeElement;

    return el.offsetWidth;
  }

  get visibleItemCount() : number {
    let itemSizePx = this.itemSizePx;

    if (itemSizePx == 0)
      return 1;
    
    return Math.round(this.availableWidthPx / this.itemSizePx);
  }

  get scrollOffset() : number {
    let scrollPos = this.scrollPosition;
    let margin = this.itemSizeMargin;
    let fullItemWidth = this.itemSizePx + margin;

    return scrollPos * fullItemWidth;
  }

  onResize() {
    let visibleItemCount = this.visibleItemCount;
    if (this.scrollPosition >= this.items.length - visibleItemCount + 1) {
      this.scrollPosition = 0;
    }
  }

  next() {
    if (!this.items)
      return;
    
    let visibleItemCount = this.visibleItemCount;

    if (this.scrollPosition + 1 >= this.items.length - visibleItemCount + 1) {
      this.scrollPosition = 0;
    } else {
      this.scrollPosition += 1;
    }
  }

  previous() {
    if (!this.items)
      return;

    if (this.scrollPosition == 0) {
      let visibleItemCount = this.visibleItemCount;
      this.scrollPosition = this.items.length - visibleItemCount;
    } else {
      this.scrollPosition -= 1;
    }
  }

}
